import { FETCH_SHIPMENT_LIST_FAILURE, FETCH_SHIPMENT_LIST_REQUEST, FETCH_SHIPMENT_LIST_REST, FETCH_SHIPMENT_LIST_SUCCESS, } from "@/redux/actions";
const initialState = {
    fetchOrders: [],
    loading: false,
    error: null,
};
const ShipmentListReducer = (state = initialState, action) => {
    switch (action.type) {
        case FETCH_SHIPMENT_LIST_SUCCESS:
            return Object.assign(Object.assign({}, state), { loading: false, error: null, fetchOrders: action.payload });
        case FETCH_SHIPMENT_LIST_REQUEST:
            return Object.assign(Object.assign({}, state), { loading: true, fetchOrders: null, error: null });
        case FETCH_SHIPMENT_LIST_FAILURE:
            return Object.assign(Object.assign({}, state), { loading: false, error: action.payload });
        case FETCH_SHIPMENT_LIST_REST:
            return Object.assign(Object.assign({}, state), { loading: false, error: null, fetchOrders: null });
        default:
            return state;
    }
};
export default ShipmentListReducer;
